import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Popup } from '../../../common/popup'
import { ScrollComponent } from '../../../common/scrollComponent'
import { MAIN_SCREEN, TYPE_ITEM_PDF } from '../constant'
import classes from '../index.module.scss'
import { TitlePanelSetting } from '../preferenceSetting/detailTemplate/TitlePanelSetting'

const PopupPreviewSingleBox = ({ panel, data, setDefault }) => {
  const items = data.reduce((total, page) => {
    return total.concat(page.items)
  }, [])

  const content = items.filter(
    ({ type }) => type === TYPE_ITEM_PDF.CONTENT_PANEL,
  )

  return (
    <Popup
      appendStyleContent={{
        padding: '20px',
        backgroundColor: '#F3F3F3',
        width: 1000,
        borderRadius: '4px',
      }}
    >
      <div className="dFlex alignItemsCenter">
        <Element
          className="w100"
          style={{ color: '#0553A5', fontSize: 20, wordBreak: 'break-word' }}
        >
          <TitlePanelSetting label={panel.label} />
          <span>
            {panel.mainScreen === MAIN_SCREEN.COMPANY_ANALYSIS ? '(C)' : '(P)'}
          </span>
        </Element>
        <Icon
          style={{ color: '#9C9C9C' }}
          className="icon-delete pl3"
          onClick={setDefault}
        />
      </div>
      <div className={classes.mt12}>
        <ScrollComponent autoHeight autoHeightMax={600}>
          {content.map(({ img }, index) => (
            <Element
              style={{ backgroundColor: '#FFFFFF' }}
              key={index}
              className={`${index ? classes.mt12 : ''} px1 py1`}
            >
              <img src={img} alt="img" className="w100" />
            </Element>
          ))}
        </ScrollComponent>
      </div>
      <div className={`${classes.mt12} dFlex justifyContentEnd`}>
        <Element
          style={{ backgroundColor: '#FFFFFF', border: '1px solid #D5D5D5' }}
          className={classes.btnClose}
          onClick={setDefault}
        >
          <Translate value="preferenceSetting.CLOSE" />
        </Element>
      </div>
    </Popup>
  )
}

export default PopupPreviewSingleBox
